import { render, staticRenderFns } from "./DepartureDates.vue?vue&type=template&id=36a17ad7&"
import script from "./DepartureDates.vue?vue&type=script&lang=js&"
export * from "./DepartureDates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports